import React from 'react'
import {uploadFormComponents} from '@modifi/plugin-documents'

const FileQueueEntry = (props: any) => <uploadFormComponents.FileQueueEntry {...props} />

export default FileQueueEntry
